import useSWR from "swr";

import { getAdminProductAddons } from "../services/order.service";
import { SWRType } from "../types/global";
import { ProductAddonFilters } from "../types/order";

const useCrmProductAddons = (
  autoFetch = false,
  filters: ProductAddonFilters = {},
) => {
  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch ? ["crm-admin-product-addons", filters] : null,
    ([, queryParams]) =>
      getAdminProductAddons({
        ...queryParams,
        ...(Array.isArray(queryParams?.sort) && queryParams.sort.length > 0
          ? { sort: queryParams.sort.join(",") }
          : {}),
      } as any),
    {
      onErrorRetry: (fetchError) => {
        if (fetchError.status === 404) return;
      },
    },
  );

  return {
    data,
    dataLoading,
    mutate,
    error,
  };
};

export default useCrmProductAddons;
